import { useEffect, useState } from "react";

interface BackgroundVideoProps {
  src: string;
  poster: string;
  className?: string;
}

// Decorative autoplay background. Phones, data-saver and reduced-motion visitors get only
// the poster image: the videos are 5-20 MB, too heavy for a mobile first load. On larger
// screens the video is added after hydration, so the prerendered HTML is the poster alone.
const BackgroundVideo = ({ src, poster, className }: BackgroundVideoProps) => {
  const [playVideo, setPlayVideo] = useState(false);

  useEffect(() => {
    const saveData = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection?.saveData;
    const wide = window.matchMedia("(min-width: 768px)").matches;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setPlayVideo(wide && !saveData && !reducedMotion);
  }, []);

  return (
    <>
      <img src={poster} alt="" aria-hidden="true" className={`absolute inset-0 ${className ?? ""}`} />
      {playVideo && (
        <video
          autoPlay
          muted
          loop
          playsInline
          poster={poster}
          className={`absolute inset-0 ${className ?? ""}`}
        >
          <source src={src} type="video/mp4" />
        </video>
      )}
    </>
  );
};

export default BackgroundVideo;
